export default __webpack_public_path__ + "static/media/Snd_TryA.46cb18c4.mp3";